import { useCallback, useState } from 'react';
import { useQuery } from '@common-fe/common-fe';
import _ from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { useDownloadCSV, useGetEmployerIdParam } from '../../hooks';
import { CardStatusSummaryReportParams } from '../CardStatusReport.types';

export const QUERY_KEY = 'EXPORT_CARD_STATUS_SUMMARY_REPORT_CSV';
const useForfeitureReportExportSummaryCSVQuery = (params: CardStatusSummaryReportParams) => {
  const handleSaveFile = useDownloadCSV();
  const [isLoading, setIsLoading] = useState(false);
  const getEmployerIdParam = useGetEmployerIdParam({
    isMultipleEmployerMode: params.isMultipleEmployer || false,
  });
  const employerId = getEmployerIdParam(params.employerId, params.employerIds);
  const { refetch } = useQuery(
    [QUERY_KEY],
    () =>
      api.get(
        params.isMultipleEmployer
          ? API_URL.REPORTS_CARD_STATUS_REPORT_MULTI_EMPLOYERS_SUMMARY_EXPORT_CSV
          : API_URL.REPORTS_CARD_STATUS_REPORT_SUMMARY_EXPORT_CSV,
        {
          params: _.pickBy({
            ...employerId,
            card_status_report_group_type: params?.cardStatusGroupType
              ? params?.cardStatusGroupType
              : undefined,
          }),
        }
      ),
    {
      retry: 0,
      enabled: false,
    }
  );

  const handleExport = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await refetch();
      handleSaveFile(response?.data?.data, 'csv', 'card-status_summary_report');
    } finally {
      setIsLoading(false);
    }
  }, [handleSaveFile, refetch]);
  return {
    isLoading,
    handleExport,
  };
};

export default useForfeitureReportExportSummaryCSVQuery;
